import { Skeleton } from "@fullscript/aviary-web";

import { Spacer } from "@aviary";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

import * as styles from "./EditPasswordForm.styles";

const SkeletonEditPasswordForm = () => {
  const { tablet } = useBreakpoints();

  return (
    <>
      <Skeleton variant="button" isFullWidth />
      <Spacer height="one" />
      <Skeleton variant="button" isFullWidth />
      <Spacer height="one" />
      <div css={styles.alignCenter}>
        <Skeleton variant="button" isFullWidth={!tablet.greaterThan} />
      </div>
    </>
  );
};

export { SkeletonEditPasswordForm };
